import React, { memo } from "react";
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from '@chakra-ui/react'
import { AccordionItemLink } from "../../molecules/SidebarAccordionItemLink";
import { AccordionList } from "../../molecules/SidebarAccordionPanelList";


export const MenuAccordionMenu: React.FC = memo(() => {
  return (
    <AccordionItem border='none'>
      <AccordionButton>
        <Box as="span" flex='1' textAlign='left' fontWeight='bold'>
          メニュー
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <AccordionList>
          <AccordionItemLink to={`menu`} text="メニュー一覧" />
          <AccordionItemLink to={`menu/setting`} text="メニュー設定" />
        </AccordionList>
      </AccordionPanel>
    </AccordionItem>
  );
});